import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// ScrollTriggerをGSAPに登録
gsap.registerPlugin(ScrollTrigger);

export function sideFadeInMove() {
  document.querySelectorAll(".js-side-section").forEach((section) => {
    // 各セクションごとにタイムラインを作成
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section, // 各セクションごとのスクロールトリガー
        start: "top 80%", // スクロール位置でアニメーションを開始
        toggleActions: "play none none none", // スクロール時のアニメーションのアクション
      },
    });

    // セクション内のjs-side-fadein要素のみを対象にアニメーションを設定
    section.querySelectorAll(".js-side-fadein").forEach((element) => {
      const isLeft = element.classList.contains("js-left"); // 左からのアニメーションかどうかの判定
      const fromX = isLeft ? "-100%" : "100%"; // js-left は左から、js-right は右から

      tl.fromTo(
        element,
        {
          x: fromX, // 初期位置: 左または右からオフセット
          opacity: 0, // 初期透明度
          visibility: "visible", // アニメーション開始時に表示
        },
        {
          x: 0, // 終了位置: 元の位置
          opacity: 1, // 終了透明度: 完全に表示
          duration: 1, // アニメーションの持続時間
          ease: "power2.out", // イージング効果
        }
      );
    });
  });
}
